import { t } from 'i18next';
import React from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { deleteCustomer } from '../../pages/Customers/CustomersSlice';

const ModalDeleteCustomer = ({ show, setShow, customerId }) => {
  const token = localStorage.getItem('token');
  const dispatch = useDispatch();

  const handleClose = () => setShow(false);

  const handleDeleteCustomer = () => {
    dispatch(deleteCustomer({ token, customerId }));
    setShow(false);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t('delete-title')}</Modal.Title>
      </Modal.Header>
      <Form>
        <Modal.Body>
          <Row>
            <Col sm={12}>
              <Modal.Title>{t('delete-message')}</Modal.Title>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t('close')}
          </Button>
          <Button variant="danger" onClick={handleDeleteCustomer}>
            {t('delete-submit')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalDeleteCustomer;
